import Cookies from 'js-cookie';

// Set token in cookie for only 1 day
export const setTokenCookie = (token) => {
  Cookies.set('session-token', token, {
    expires: 1, // expires in 1 day
    secure: true, // only over HTTPS
    sameSite: 'Strict', // prevent CSRF
    path: '/' // accessible everywhere
  });
};

// Get token from cookie
export const getTokenCookie = () => {
  return Cookies.get('session-token');
};

// Remove token from cookie
export const removeTokenCookie = () => {
  Cookies.remove('session-token');
};
